import { cva } from 'class-variance-authority';
import { FontWeights } from '../enums/font-weights';
import { DisplaySizes } from '../enums/typography-display-sizes';

export const displayVariants = cva('', {
  variants: {
    size: {
      [DisplaySizes.TWO_XL]:
        'text-[4.5rem] leading-[5.625rem] tracking-[-0.02em]',
      [DisplaySizes.XL]: 'text-[3.75rem] leading-[4.5rem] tracking-[-0.02em]',
      [DisplaySizes.LG]: 'text-[3rem] leading-[3.75rem] tracking-[-0.02em]',
      [DisplaySizes.MD]: 'text-[2.25rem] leading-[2.75rem] tracking-[-0.02em]',
      [DisplaySizes.SM]: 'text-[1.875rem] leading-[2.375rem]',
      [DisplaySizes.XS]: 'text-[1.5rem] leading-[2rem]',
    },
    weight: {
      [FontWeights.REGULAR]: 'font-normal',
      [FontWeights.MEDIUM]: 'font-medium',
      [FontWeights.SEMIBOLD]: 'font-semibold',
      [FontWeights.BOLD]: 'font-bold',
    },
  },
});
